// Notifications may outlive a login. Only route authenticated users to known
// destinations, and reject notifications explicitly addressed to another user.
export function notificationDestination(notification, userId) {
  if (!userId) return null;
  const data = notification?.request?.content?.data;
  if (data?.userId && String(data.userId) !== String(userId)) return null;
  const href = data?.href;
  if (typeof href !== 'string') return null;
  if (/^\/c\/[a-zA-Z0-9_-]+$/.test(href)) return href;
  return ['/tasks', '/(app)/app'].includes(href) ? href : null;
}
